var App = App || {};

App.Base = (function ($) {
    'use strict';

    function init() {
        HashSupport();
        initTooltips();
        initRichTextTables();
    }

    function initTooltips() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    }

    function initRichTextTables() {
        $('.rich-text table').addClass('table').wrap("<div class='table-responsive'></div>");
    }

    function HashSupport() {

        const Hash = $(location.hash);

        if (Hash.length == 1) {

            if (Hash.attr("data-bs-toggle") == "collapse") {
                const Target = $(Hash.attr("data-bs-target"));
                const Panel = document.getElementById(Target.attr("id"));
                const Collapse = new bootstrap.Collapse(Panel);
                Collapse.show();
            }

            else if (Hash.attr("data-bs-toggle") == "tab") {
                const Tab = new bootstrap.Tab(Hash);
                Tab.show();
            }

            else if (Hash.hasClass("modal")) {
                const Modal = new bootstrap.Modal(Hash);
                Modal.show();
            }
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Base.init();
});